module.exports = __webpack_public_path__ + "img/dark-mud-decal-17.25213985.png";